export default __webpack_public_path__ + "static/media/notes.edc7aed0.svg";